import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useParams } from 'react-router-dom';
import './ServiceCatelogue.css';
import { useTranslation } from 'react-i18next';
import SideMenu from './SideMenu';
import { Modal } from 'react-bootstrap';
import { formatDateDDMMYY } from '../../../utils/dateUtils';

const ProductCatalogue = ({selectedCategory, selectedSub }) => {
  const { t } = useTranslation();
  const [catalogue, setCatalogue] = useState([]);
  const { id } = useParams();
  const [infoShow, setinfoShow] = useState(false);
  const [infoData, setInfoData] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasNext1, setHasNext1] = useState(false);
  const [page1, setPage1] = useState(1);
  const [lastPageCalled1, setLastPageCalled1] = useState(1);
  const scrollContainerRef = useRef(null);
  const [searchProduct, setSearchProduct] = useState('');
  const [searchVendorId, setSearchVendorId] = useState('');
  const [searchVendorName, setSearchVendorName] = useState('');
  const abortControllerRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  // Load initial data with debouncing
  useEffect(() => {
    if(selectedCategory === "Products"){
      // Clear previous timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      
      // Cancel any ongoing request
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Reset state
      setLastPageCalled1(1);
      setPage1(1);
      setCatalogue([]);

      // Debounce the API call
      searchTimeoutRef.current = setTimeout(() => {
        handleLoad(1);
      }, 300); // 300ms debounce

      return () => {
        if (searchTimeoutRef.current) {
          clearTimeout(searchTimeoutRef.current);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchProduct, searchVendorId, searchVendorName, selectedSub, selectedCategory]);

  const handleLoad = useCallback(async (currentPage) => {
    // Cancel any previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create new abort controller for this request
    abortControllerRef.current = new AbortController();

    setLoading(true);
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["']+/g, '');

    try {
      const res = await axios.get(`${APIURL}/api/v1/staff/product-catalogue/?vendor_id=${searchVendorId}&vendor_name=${searchVendorName}&search=${searchProduct}&category=${selectedSub || ''}&${TZ}&page=${currentPage}`, {
        headers: {
          "Authorization": 'Token ' + str
        },
        signal: abortControllerRef.current.signal
      });

      if (res.data.status === "success") {
        const newData = res.data.message;
        setCatalogue(prevCatalogue => {
          // Check for duplicates before adding
          const existingIds = new Set(prevCatalogue.map(item => item.id));
          const uniqueNewData = newData.filter(item => !existingIds.has(item.id));
          return [...prevCatalogue, ...uniqueNewData];
        });
        setHasNext1(res.data.has_next);
        setPage1(res.data.page + 1);
      }
    } catch (err) {
      if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
        console.error('Error loading catalogue:', err);
      }
    } finally {
      setLoading(false);
    }
  }, [searchProduct, searchVendorId, searchVendorName, selectedSub]);

  // Scroll handler with debouncing
  const handleScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
    const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50;

    if (isNearBottom && hasNext1 && page1 !== lastPageCalled1 && !loading) {
      setLastPageCalled1(page1);
      handleLoad(page1);
    }
  }, [hasNext1, page1, lastPageCalled1, loading, handleLoad]);

  // Add scroll event listener
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const handleInfoPopUp = (item) => {
    setInfoData(item);
    setinfoShow(true);
  };

  const InfoPopup = (props) => {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h6>{infoData.name?.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <fieldset className='field_set'>
              <legend style={{ size: "5" }}>
                <div className="row-of-features">
                  <div className="col-of-features" style={{padding:"1%"}}>
                    <div className='row'>
                        <h6 className='info col-6'>{t('serviceCatalogue.fee')}</h6><h6 className='info col-6'>{infoData.currency}{" "}{infoData.amount}</h6>
                        <h6 className='info col-6'>{t('serviceCatalogue.description')}</h6><h6 className='info col-6'>{infoData.description}</h6>
                        <h6 className='info col-6'>{t('serviceCatalogue.shortDescription')}</h6><h6 className='info col-6'>{infoData.short_description}</h6>
                    </div>
                  </div>
                </div>
              </legend>
            </fieldset>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  let display = catalogue.length > 0 ? catalogue.map((data, index) => {
    return (
      <div className="row" key={data.id}
        style={{
          fontSize: "13px",
          cursor: "pointer",
          textAlign: "left",
          borderLeft: "0.4px solid #5f5e5e7a",
          borderBottom: "0.4px solid #5f5e5e7a",
          borderRight: "0.4px solid #5f5e5e7a",
          boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)",
          marginBottom: "0.5%"
        }}>
        <div style={{
          backgroundColor: "#40E0D036",
          padding: "1%",
          borderRight: "0.4px solid #5f5e5e7a",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }} className="col-2" title={data.product_name}>{data.product_name}</div>
        <div style={{ padding: "1%" }} className="col-2">{data.catalogue_id}</div>
        <div style={{ padding: "1%" }} className="col-2">{data.quantity_in_stock}</div>
        <div style={{ padding: "1%",textTransform:"capitalize" }} className="col-2">{data.vendor_name}</div>
        <div style={{ padding: "1%" }} className="col-2">{data.vendor_id}</div>
        
        <div style={{ padding: "1%" }} className="col-2">{formatDateDDMMYY(new Date(data.created_at))}</div>
      </div>
    );
  }) : null;

  return (<>
   <div className="col-10" ref={scrollContainerRef}
    style={{
      maxHeight: '71vh',
      overflowY: 'auto',
      position: 'relative',
      paddingRight: '10px', display: 'flex'
    }}  >
          <div className="container">
            <div className='row'>
              <div className="col-12">
                <div className="search-div row">
                  <div className="col-5">
                    <input
                      type="text"
                      className="search-clinics"
                      placeholder={t('serviceCatalogue.searchByProduct')}
                      value={searchProduct}
                      onChange={(e) => setSearchProduct(e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    <input
                      type="text"
                      className="search-clinics"
                      placeholder={t('serviceCatalogue.searchByVendorId')}
                      value={searchVendorId}
                      onChange={(e) => setSearchVendorId(e.target.value)}
                    />
                  </div>
                  <div className="col-4">
                    <input
                      type="text"
                      className="search-clinics"
                      placeholder={t('serviceCatalogue.searchByVendorName')}
                      value={searchVendorName}
                      onChange={(e) => setSearchVendorName(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className=""  style={{ margin: "auto" }}>
              <div className="container">
                <div
                  className="test-reports-display-list"
                >
                    <>
                      <div className="row" style={{
                        backgroundColor: "#01C9C9",
                        color: "white",
                        textAlign: "left",
                        padding: "1%",
                        borderRadius: "5px 5px 0px 0px",
                        boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)",
                        marginBottom: "0.5%",
                        fontSize: "12px",
                        position: 'sticky',
                        top: 0,
                        zIndex: 1
                      }}>
                        <div className="col-2"><b>{t('productCatalogue.headers.productName')}</b></div>
                        <div className="col-2"><b>{t('productCatalogue.headers.catalogueId')}</b></div>
                        <div className="col-2"><b>{t('productCatalogue.headers.quantityInStock')}</b></div>
                        <div className="col-2"><b>{t('productCatalogue.headers.vendor')}</b></div>
                        <div className="col-2"><b>{t('productCatalogue.headers.vendorId')}</b></div>
                        <div className="col-2"><b>{t('productCatalogue.headers.createdAt')}</b></div>
                      </div>
                      {display}
                      {loading && (
                        <div className="text-center py-3">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </>
                </div>
              </div>
            </div>
          </div>
        </div>
      {infoShow ?
        <InfoPopup
          show={infoShow}
          onHide={() => {
            setinfoShow(false);
          }}
        /> : null
      }
    </>
  );
};

export default ProductCatalogue;
